import { useState } from "react";

/**
 * Hook for managing menu/kebab actions
 */
export const useMenuActions = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRx, setSelectedRx] = useState<any | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>, rx: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedRx(rx);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const clearSelection = () => {
    setSelectedRx(null);
    setAnchorEl(null);
  };

  return {
    anchorEl,
    selectedRx,
    setSelectedRx,
    handleMenuOpen,
    handleMenuClose,
    clearSelection,
  };
};
